// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__3YBJd","info":"Panel_info__T1e6d","note":"Panel_note__71D2p","close":"Panel_close__4qcQ-","btns":"Panel_btns__ldxeF","button":"Panel_button__ERrdU"};